module.exports = __webpack_public_path__ + "img/SingleLine.1287c2f9.svg";